// src/App.js
import React, { useEffect, useMemo, useRef, useState } from "react";

/* -----------------------------
   DATA — N5 (103 kanji)
----------------------------- */
const N5_KANJI_RAW = [
  { kanji: "一", meaning: "One", story: "1 horizontal line." },
  { kanji: "二", meaning: "Two", story: "2 horizontal lines." },
  { kanji: "三", meaning: "Three", story: "3 horizontal lines." },
  { kanji: "四", meaning: "Four", story: "A square window with curtains." },
  { kanji: "五", meaning: "Five", story: "Looks like a digital number 5." },
  { kanji: "六", meaning: "Six", story: "A person wearing a hat." },
  { kanji: "七", meaning: "Seven", story: "An upside-down number 7." },
  { kanji: "八", meaning: "Eight", story: "The shape of an open gate." },
  { kanji: "九", meaning: "Nine", story: "A person sitting on the floor." },
  { kanji: "十", meaning: "Ten", story: "A plus sign (+)." },
  { kanji: "百", meaning: "Hundred", story: "Number 1 + Sun." },
  { kanji: "千", meaning: "Thousand", story: "The letter T with a crossbar." },
  { kanji: "万", meaning: "10,000", story: "A person with a sword." },
  { kanji: "円", meaning: "Yen/Circle", story: "A frame for a coin." },
  { kanji: "日", meaning: "Sun/Day", story: "A window looking at the sun." },
  { kanji: "月", meaning: "Moon/Month", story: "A crescent moon with lines." },
  { kanji: "火", meaning: "Fire", story: "A campfire with sparks." },
  { kanji: "水", meaning: "Water", story: "A splashing water fountain." },
  { kanji: "木", meaning: "Tree", story: "A trunk with branches." },
  { kanji: "金", meaning: "Gold/Money", story: "A roof over gold nuggets." },
  { kanji: "土", meaning: "Soil", story: "A cross standing in the ground." },
  { kanji: "山", meaning: "Mountain", story: "Three mountain peaks." },
  { kanji: "川", meaning: "River", story: "Three lines of flowing water." },
  { kanji: "天", meaning: "Heaven", story: "A person with the sky above him." },
  { kanji: "気", meaning: "Spirit", story: "Steam rising from a pot." },
  { kanji: "雨", meaning: "Rain", story: "Raindrops inside a window." },
  { kanji: "花", meaning: "Flower", story: "Grass + a person changing." },
  { kanji: "空", meaning: "Sky", story: "A roof over a big space." },
  { kanji: "魚", meaning: "Fish", story: "Fish head, body, and tail." },
  { kanji: "電", meaning: "Electricity", story: "Rain + a power cord." },
  { kanji: "人", meaning: "Person", story: "Two legs walking." },
  { kanji: "子", meaning: "Child", story: "A baby with open arms." },
  { kanji: "女", meaning: "Woman", story: "A woman crossing her legs." },
  { kanji: "男", meaning: "Man", story: "Rice field + Power." },
  { kanji: "父", meaning: "Father", story: "A man with a mustache." },
  { kanji: "母", meaning: "Mother", story: "A woman with two dots (nursing)." },
  { kanji: "友", meaning: "Friend", story: "Two hands holding each other." },
  { kanji: "生", meaning: "Life", story: "A plant growing up." },
  { kanji: "名", meaning: "Name", story: "Mouth speaking in the evening." },
  { kanji: "上", meaning: "Up", story: "Pointing above the line." },
  { kanji: "下", meaning: "Down", story: "Pointing below the line." },
  { kanji: "中", meaning: "Middle", story: "A line through a box." },
  { kanji: "外", meaning: "Outside", story: "Evening + smoking a pipe outside." },
  { kanji: "左", meaning: "Left", story: "Hand holding a tool." },
  { kanji: "右", meaning: "Right", story: "Hand putting food in mouth." },
  { kanji: "前", meaning: "Front", story: "Standing in front of a horn." },
  { kanji: "後", meaning: "Behind", story: "Walking slowly behind someone." },
  { kanji: "北", meaning: "North", story: "Two people back-to-back (cold)." },
  { kanji: "南", meaning: "South", story: "A warm house with a fence." },
  { kanji: "東", meaning: "East", story: "Sun rising behind a tree." },
  { kanji: "西", meaning: "West", story: "A bird in a square nest." },
  { kanji: "年", meaning: "Year", story: "A person with a harvest." },
  { kanji: "時", meaning: "Time", story: "Sun + Temple." },
  { kanji: "分", meaning: "Minute", story: "A knife cutting in half." },
  { kanji: "間", meaning: "Between", story: "Sun in the middle of a gate." },
  { kanji: "今", meaning: "Now", story: "A clock under a roof." },
  { kanji: "毎", meaning: "Every", story: "A mother with a hat." },
  { kanji: "週", meaning: "Week", story: "A circle on the road." },
  { kanji: "午", meaning: "Noon", story: "A horse at high noon." },
  { kanji: "半", meaning: "Half", story: "A line cutting through two parts." },
  { kanji: "行", meaning: "Go", story: "Footprints on a sidewalk." },
  { kanji: "来", meaning: "Come", story: "A person coming to a tree." },
  { kanji: "出", meaning: "Exit", story: "One mountain on another mountain." },
  { kanji: "入", meaning: "Enter", story: "A person walking into a tent." },
  { kanji: "見", meaning: "See", story: "An eye on legs." },
  { kanji: "聞", meaning: "Hear", story: "An ear inside a gate." },
  { kanji: "言", meaning: "Say", story: "A mouth with sound waves." },
  { kanji: "話", meaning: "Speak", story: "Speech + a tongue." },
  { kanji: "読", meaning: "Read", story: "Speech + a person with a book." },
  { kanji: "書", meaning: "Write", story: "A hand holding a pen." },
  { kanji: "食", meaning: "Eat", story: "A person eating under a roof." },
  { kanji: "飲", meaning: "Drink", story: "A person with an open mouth." },
  { kanji: "買", meaning: "Buy", story: "A shopping net over money." },
  { kanji: "立", meaning: "Stand", story: "A person standing on a rug." },
  { kanji: "休", meaning: "Rest", story: "A person leaning on a tree." },
  { kanji: "大", meaning: "Big", story: "Person with arms wide open." },
  { kanji: "小", meaning: "Small", story: "Person with arms down." },
  { kanji: "高", meaning: "High", story: "A tall building with a roof." },
  { kanji: "安", meaning: "Cheap/Safe", story: "A woman sitting in a house." },
  { kanji: "新", meaning: "New", story: "Standing on a tree with an axe." },
  { kanji: "古", meaning: "Old", story: "A story told 10 times." },
  { kanji: "長", meaning: "Long", story: "A person with very long hair." },
  { kanji: "多", meaning: "Many", story: "Two moons (lots of moons)." },
  { kanji: "少", meaning: "Few", story: "Small + a slash cutting it." },
  { kanji: "白", meaning: "White", story: "A single drop of sunlight." },
  { kanji: "手", meaning: "Hand", story: "Five fingers on a palm." },
  { kanji: "足", meaning: "Foot", story: "A leg and a foot." },
  { kanji: "目", meaning: "Eye", story: "A vertical eye with a pupil." },
  { kanji: "耳", meaning: "Ear", story: "A picture of an ear." },
  { kanji: "口", meaning: "Mouth", story: "A square opening." },
  { kanji: "本", meaning: "Book", story: "A tree with a root line." },
  { kanji: "語", meaning: "Language", story: "Speech + 5 + Mouth." },
  { kanji: "学", meaning: "Study", story: "A child in a school." },
  { kanji: "校", meaning: "School", story: "A tree where people meet." },
  { kanji: "国", meaning: "Country", story: "A king inside a border." },
  { kanji: "社", meaning: "Company", story: "An altar on the ground." },
  { kanji: "車", meaning: "Car", story: "A car seen from the top." },
  { kanji: "駅", meaning: "Station", story: "A horse at the stop." },
  { kanji: "道", meaning: "Road", story: "A head walking on a path." },
  { kanji: "店", meaning: "Shop", story: "A roof over a fortune teller." },
  { kanji: "何", meaning: "What", story: "A person carrying something." },
  { kanji: "力", meaning: "Power", story: "A strong arm muscle." },
  { kanji: "先", meaning: "Ahead", story: "A person walking first." },
];

/* -----------------------------
   DATA — N4 (181 kanji — updated list)
----------------------------- */
const N4_KANJI_RAW = [
  { kanji: "不", meaning: "Not", story: "A line blocking = no." },
  { kanji: "世", meaning: "World", story: "Three layers = generations." },
  { kanji: "主", meaning: "Main", story: "A flame on top = main." },
  { kanji: "乗", meaning: "Ride", story: "A person standing on something." },
  { kanji: "事", meaning: "Thing", story: "Handling a task." },
  { kanji: "京", meaning: "Capital", story: "A big city building." },
  { kanji: "仕", meaning: "Do", story: "A person working." },
  { kanji: "代", meaning: "Replace", story: "One person replaces another." },
  { kanji: "以", meaning: "From", story: "Starting point." },
  { kanji: "低", meaning: "Low", story: "Standing low." },
  { kanji: "住", meaning: "Live", story: "A person staying." },
  { kanji: "体", meaning: "Body", story: "Human body." },
  { kanji: "作", meaning: "Make", story: "A person creating." },
  { kanji: "使", meaning: "Use", story: "Using something." },
  { kanji: "便", meaning: "Mail", story: "Delivering letters." },
  { kanji: "借", meaning: "Borrow", story: "Take then return." },
  { kanji: "働", meaning: "Work", story: "Working hard." },
  { kanji: "元", meaning: "Origin", story: "The beginning." },
  { kanji: "兄", meaning: "Older Brother", story: "Older person." },
  { kanji: "光", meaning: "Light", story: "Light shining." },
  { kanji: "写", meaning: "Copy", story: "Make a copy." },
  { kanji: "冬", meaning: "Winter", story: "Cold drops." },
  { kanji: "切", meaning: "Cut", story: "Knife cutting." },
  { kanji: "別", meaning: "Separate", story: "Cut apart." },
  { kanji: "力", meaning: "Power", story: "Strong arm." },
  { kanji: "勉", meaning: "Effort", story: "Trying hard." },
  { kanji: "動", meaning: "Move", story: "Power moves." },
  { kanji: "区", meaning: "Area", story: "Divided space." },
  { kanji: "医", meaning: "Doctor", story: "Medical tools." },
  { kanji: "去", meaning: "Leave", story: "Go away." },
  { kanji: "台", meaning: "Stand", story: "A platform." },
  { kanji: "合", meaning: "Fit", story: "Things match." },
  { kanji: "同", meaning: "Same", story: "Exactly same." },
  { kanji: "味", meaning: "Taste", story: "Mouth tasting." },
  { kanji: "品", meaning: "Goods", story: "Three items." },
  { kanji: "員", meaning: "Member", story: "Group person." },
  { kanji: "問", meaning: "Question", story: "Mouth asking." },
  { kanji: "回", meaning: "Times", story: "Going around." },
  { kanji: "図", meaning: "Map", story: "A plan drawing." },
  { kanji: "地", meaning: "Ground", story: "The earth." },
  { kanji: "堂", meaning: "Hall", story: "Big building." },
  { kanji: "場", meaning: "Place", story: "Open area." },
  { kanji: "声", meaning: "Voice", story: "Sound from person." },
  { kanji: "売", meaning: "Sell", story: "Selling goods." },
  { kanji: "夏", meaning: "Summer", story: "Hot sun." },
  { kanji: "夕", meaning: "Evening", story: "Moon at dusk." },
  { kanji: "夜", meaning: "Night", story: "Dark time." },
  { kanji: "太", meaning: "Big", story: "A big person." },
  { kanji: "好", meaning: "Like", story: "Love child." },
  { kanji: "妹", meaning: "Younger Sister", story: "Young girl." },
  { kanji: "姉", meaning: "Older Sister", story: "Older woman." },
  { kanji: "始", meaning: "Begin", story: "Start something." },
  { kanji: "字", meaning: "Letter", story: "Learning writing." },
  { kanji: "室", meaning: "Room", story: "Inside house." },
  { kanji: "家", meaning: "House", story: "Roof shelter." },
  { kanji: "寒", meaning: "Cold", story: "Cold inside." },
  { kanji: "屋", meaning: "Shop", story: "Roof place." },
  { kanji: "工", meaning: "Build", story: "Tool work." },
  { kanji: "市", meaning: "City", story: "Busy market." },
  { kanji: "帰", meaning: "Return", story: "Go home." },
  { kanji: "広", meaning: "Wide", story: "Wide space." },
  { kanji: "度", meaning: "Degree", story: "Measure amount." },
  { kanji: "建", meaning: "Build", story: "Make building." },
  { kanji: "引", meaning: "Pull", story: "Pull something." },
  { kanji: "弟", meaning: "Younger Brother", story: "Young boy." },
  { kanji: "弱", meaning: "Weak", story: "Not strong." },
  { kanji: "強", meaning: "Strong", story: "Very strong." },
  { kanji: "待", meaning: "Wait", story: "Stand waiting." },
  { kanji: "心", meaning: "Heart", story: "The heart." },
  { kanji: "思", meaning: "Think", story: "Heart thinking." },
  { kanji: "急", meaning: "Hurry", story: "Heart rushing." },
  { kanji: "悪", meaning: "Bad", story: "Bad feeling." },
  { kanji: "意", meaning: "Meaning", story: "Thought inside." },
  { kanji: "所", meaning: "Place", story: "A location." },
  { kanji: "持", meaning: "Hold", story: "Hand holding." },
  { kanji: "教", meaning: "Teach", story: "Teaching child." },
  { kanji: "文", meaning: "Sentence", story: "Written lines." },
  { kanji: "料", meaning: "Fee", story: "Measured amount." },
  { kanji: "方", meaning: "Direction", story: "Way to go." },
  { kanji: "旅", meaning: "Travel", story: "Going far." },
  { kanji: "族", meaning: "Family", story: "Group of people." },
  { kanji: "早", meaning: "Early", story: "Sun rising." },
  { kanji: "明", meaning: "Bright", story: "Sun + moon." },
  { kanji: "映", meaning: "Reflect", story: "Light showing." },
  { kanji: "春", meaning: "Spring", story: "Sun grows plants." },
  { kanji: "昼", meaning: "Daytime", story: "Sun high." },
  { kanji: "暑", meaning: "Hot", story: "Hot sun." },
  { kanji: "暗", meaning: "Dark", story: "No light." },
  { kanji: "曜", meaning: "Weekday", story: "Sun repeating." },
  { kanji: "有", meaning: "Have", story: "Holding something." },
  { kanji: "服", meaning: "Clothes", story: "Wearing clothes." },
  { kanji: "朝", meaning: "Morning", story: "Sun rising." },
  { kanji: "村", meaning: "Village", story: "Small town." },
  { kanji: "林", meaning: "Woods", story: "Two trees." },
  { kanji: "森", meaning: "Forest", story: "Three trees." },
  { kanji: "業", meaning: "Work", story: "Doing job." },
  { kanji: "楽", meaning: "Fun", story: "Enjoy music." },
  { kanji: "歌", meaning: "Song", story: "Mouth singing." },
  { kanji: "止", meaning: "Stop", story: "Foot stops." },
  { kanji: "正", meaning: "Correct", story: "Right stop." },
  { kanji: "歩", meaning: "Walk", story: "Step forward." },
  { kanji: "死", meaning: "Death", story: "Life ends." },
  { kanji: "民", meaning: "People", story: "Group of people." },
  { kanji: "池", meaning: "Pond", story: "Water place." },
  { kanji: "注", meaning: "Pour", story: "Water flows." },
  { kanji: "洋", meaning: "Ocean", story: "Big water." },
  { kanji: "洗", meaning: "Wash", story: "Clean with water." },
  { kanji: "海", meaning: "Sea", story: "Wide water." },
  { kanji: "漢", meaning: "China", story: "Big river land." },
  { kanji: "牛", meaning: "Cow", story: "Animal horns." },
  { kanji: "物", meaning: "Thing", story: "Any object." },
  { kanji: "特", meaning: "Special", story: "Different thing." },
  { kanji: "犬", meaning: "Dog", story: "Pet animal." },
  { kanji: "理", meaning: "Reason", story: "Understanding." },
  { kanji: "産", meaning: "Produce", story: "Make something." },
  { kanji: "用", meaning: "Use", story: "Using tool." },
  { kanji: "田", meaning: "Field", story: "Rice field." },
  { kanji: "町", meaning: "Town", story: "Small city." },
  { kanji: "画", meaning: "Picture", story: "Drawing." },
  { kanji: "界", meaning: "World", story: "Boundaries." },
  { kanji: "病", meaning: "Sick", story: "Ill person." },
  { kanji: "発", meaning: "Start", story: "Begin moving." },
  { kanji: "県", meaning: "Prefecture", story: "Area division." },
  { kanji: "真", meaning: "True", story: "Real thing." },
  { kanji: "着", meaning: "Wear", story: "Put on clothes." },
  { kanji: "知", meaning: "Know", story: "Understand." },
  { kanji: "短", meaning: "Short", story: "Not long." },
  { kanji: "研", meaning: "Study", story: "Research." },
  { kanji: "私", meaning: "I", story: "Myself." },
  { kanji: "秋", meaning: "Autumn", story: "Fall season." },
  { kanji: "究", meaning: "Research", story: "Study deeply." },
  { kanji: "答", meaning: "Answer", story: "Reply." },
  { kanji: "紙", meaning: "Paper", story: "Writing sheet." },
  { kanji: "終", meaning: "End", story: "Finish." },
  { kanji: "習", meaning: "Learn", story: "Practice." },
  { kanji: "考", meaning: "Think", story: "Consider." },
  { kanji: "者", meaning: "Person", story: "Someone." },
  { kanji: "肉", meaning: "Meat", story: "Food." },
  { kanji: "自", meaning: "Self", story: "Myself." },
  { kanji: "色", meaning: "Color", story: "Color shade." },
  { kanji: "英", meaning: "English", story: "Foreign language." },
  { kanji: "茶", meaning: "Tea", story: "Drink." },
  { kanji: "菜", meaning: "Vegetable", story: "Plant food." },
  { kanji: "薬", meaning: "Medicine", story: "Healing." },
  { kanji: "親", meaning: "Parent", story: "Family elder." },
  { kanji: "計", meaning: "Measure", story: "Count." },
  { kanji: "試", meaning: "Test", story: "Try." },
  { kanji: "説", meaning: "Explain", story: "Say clearly." },
  { kanji: "貸", meaning: "Lend", story: "Give temporarily." },
  { kanji: "質", meaning: "Quality", story: "Nature of thing." },
  { kanji: "赤", meaning: "Red", story: "Red color." },
  { kanji: "走", meaning: "Run", story: "Move fast." },
  { kanji: "起", meaning: "Wake", story: "Stand up." },
  { kanji: "転", meaning: "Turn", story: "Spin." },
  { kanji: "軽", meaning: "Light", story: "Not heavy." },
  { kanji: "近", meaning: "Near", story: "Close." },
  { kanji: "送", meaning: "Send", story: "Send away." },
  { kanji: "通", meaning: "Go through", story: "Pass." },
  { kanji: "進", meaning: "Advance", story: "Move forward." },
  { kanji: "運", meaning: "Move", story: "Carry." },
  { kanji: "遠", meaning: "Far", story: "Long distance." },
  { kanji: "都", meaning: "City", story: "Big city." },
  { kanji: "重", meaning: "Heavy", story: "Weight." },
  { kanji: "野", meaning: "Field", story: "Open land." },
  { kanji: "銀", meaning: "Silver", story: "Metal." },
  { kanji: "門", meaning: "Gate", story: "Door gate." },
  { kanji: "開", meaning: "Open", story: "Open gate." },
  { kanji: "院", meaning: "Institute", story: "Large building." },
  { kanji: "集", meaning: "Gather", story: "Come together." },
  { kanji: "青", meaning: "Blue", story: "Blue color." },
  { kanji: "音", meaning: "Sound", story: "Noise." },
  { kanji: "頭", meaning: "Head", story: "Top body." },
  { kanji: "題", meaning: "Topic", story: "Main idea." },
  { kanji: "顔", meaning: "Face", story: "Front head." },
  { kanji: "風", meaning: "Wind", story: "Air moving." },
  { kanji: "飯", meaning: "Meal", story: "Food." },
  { kanji: "館", meaning: "Building", story: "Large place." },
  { kanji: "首", meaning: "Neck", story: "Between head." },
  { kanji: "験", meaning: "Test", story: "Exam." },
  { kanji: "鳥", meaning: "Bird", story: "Flying animal." },
  { kanji: "黒", meaning: "Black", story: "Dark color." },
];

const N5_READINGS = {
  一: "いち", 二: "に", 三: "さん", 四: "よん", 五: "ご", 六: "ろく", 七: "なな",
  八: "はち", 九: "きゅう", 十: "じゅう", 百: "ひゃく", 千: "せん", 万: "まん",
  円: "えん", 日: "にち", 月: "げつ", 火: "か", 水: "みず", 木: "もく", 金: "きん",
  土: "ど", 山: "やま", 川: "かわ", 天: "てん", 気: "き", 雨: "あめ", 花: "はな",
  空: "そら", 魚: "さかな", 電: "でん", 人: "ひと", 子: "こ", 女: "おんな",
  男: "おとこ", 父: "ちち", 母: "はは", 友: "とも", 生: "せい", 名: "な",
  上: "うえ", 下: "した", 中: "なか", 外: "そと", 左: "ひだり", 右: "みぎ",
  前: "まえ", 後: "あと", 北: "きた", 南: "みなみ", 東: "ひがし", 西: "にし",
  年: "ねん", 時: "じ", 分: "ふん", 間: "あいだ", 今: "いま", 毎: "まい",
  週: "しゅう", 午: "ご", 半: "はん", 行: "いく", 来: "くる", 出: "でる",
  入: "はいる", 見: "みる", 聞: "きく", 言: "いう", 話: "はなす", 読: "よむ",
  書: "かく", 食: "たべる", 飲: "のむ", 買: "かう", 立: "たつ", 休: "やすむ",
  大: "おお", 小: "ちい", 高: "たか", 安: "やす", 新: "あたら", 古: "ふる",
  長: "なが", 多: "おお", 少: "すく", 白: "しろ", 手: "て", 足: "あし",
  目: "め", 耳: "みみ", 口: "くち", 本: "ほん", 語: "ご", 学: "がく",
  校: "こう", 国: "くに", 社: "しゃ", 車: "くるま", 駅: "えき", 道: "みち",
  店: "みせ", 何: "なに", 力: "ちから", 先: "さき",
};

const N4_READINGS = {
  不: "ふ", 世: "せ", 主: "しゅ", 乗: "のる", 事: "こと", 京: "きょう",
  仕: "し", 代: "だい", 以: "い", 低: "ひくい", 住: "すむ", 体: "からだ",
  作: "つくる", 使: "つかう", 便: "べん", 借: "かりる", 働: "はたらく",
  元: "もと", 兄: "あに", 光: "ひかり", 写: "うつす", 冬: "ふゆ", 切: "きる",
  別: "べつ", 勉: "べんきょう", 動: "うごく", 区: "く", 医: "い", 去: "さる",
  台: "だい", 合: "あう", 同: "おなじ", 味: "あじ", 品: "しな", 員: "いん",
  問: "もんだい", 回: "かい", 図: "ず", 地: "ち", 堂: "どう", 場: "ば",
  声: "こえ", 売: "うる", 夏: "なつ", 夕: "ゆう", 夜: "よる", 太: "ふとい",
  好: "すき", 妹: "いもうと", 姉: "あね", 始: "はじめる", 字: "じ", 室: "しつ",
  家: "いえ", 寒: "さむい", 屋: "や", 工: "こう", 市: "し", 帰: "かえる",
  広: "ひろい", 度: "ど", 建: "たてる", 引: "ひく", 弟: "おとうと",
  弱: "よわい", 強: "つよい", 待: "まつ", 心: "こころ", 思: "おもう",
  急: "いそぐ", 悪: "わるい", 意: "い", 所: "ところ", 持: "もつ", 教: "おしえる",
  文: "ぶん", 料: "りょう", 方: "ほう", 旅: "たび", 族: "ぞく", 早: "はやい",
  明: "あかるい", 映: "うつる", 春: "はる", 昼: "ひる", 暑: "あつい",
  暗: "くらい", 曜: "よう", 有: "ある", 服: "ふく", 朝: "あさ", 村: "むら",
  林: "はやし", 森: "もり", 業: "ぎょう", 楽: "たのしい", 歌: "うた",
  止: "とまる", 正: "ただしい", 歩: "あるく", 死: "しぬ", 民: "みん",
  池: "いけ", 注: "ちゅう", 洋: "よう", 洗: "あらう", 海: "うみ", 漢: "かん",
  牛: "うし", 物: "もの", 特: "とく", 犬: "いぬ", 理: "り", 産: "うむ",
  用: "よう", 田: "た", 町: "まち", 画: "が", 界: "かい", 病: "びょう",
  発: "はつ", 県: "けん", 真: "まこと", 着: "きる", 知: "しる", 短: "みじかい",
  研: "けん", 私: "わたし", 秋: "あき", 究: "きゅう", 答: "こたえる",
  紙: "かみ", 終: "おわる", 習: "ならう", 考: "かんがえる", 者: "もの",
  肉: "にく", 自: "じ", 色: "いろ", 英: "えい", 茶: "ちゃ", 菜: "さい",
  薬: "くすり", 親: "おや", 計: "けい", 試: "ためす", 説: "せつ", 貸: "かす",
  質: "しつ", 赤: "あか", 走: "はしる", 起: "おきる", 転: "ころがる",
  軽: "かるい", 近: "ちかい", 送: "おくる", 通: "とおる", 進: "すすむ",
  運: "うん", 遠: "とおい", 都: "と", 重: "おもい", 野: "の", 銀: "ぎん",
  門: "もん", 開: "あける", 院: "いん", 集: "あつまる", 青: "あお",
  音: "おと", 頭: "あたま", 題: "だい", 顔: "かお", 風: "かぜ", 飯: "はん",
  館: "かん", 首: "くび", 験: "けん", 鳥: "とり", 黒: "くろ",
};

/* -----------------------------
   UTILS
----------------------------- */
function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
function dist(a, b) {
  const dx = a.x - b.x, dy = a.y - b.y;
  return Math.sqrt(dx * dx + dy * dy);
}
function angle(a, b) { return Math.atan2(b.y - a.y, b.x - a.x); }
function angleDiff(a, b) {
  let d = Math.abs(a - b);
  while (d > Math.PI) d = Math.abs(d - 2 * Math.PI);
  return d;
}
function codepointHex(kanji) {
  return kanji.codePointAt(0).toString(16).padStart(5, "0");
}

function kanaToRomaji(input = "") {
  const s = String(input || "");
  const mono = {
    あ:"a",い:"i",う:"u",え:"e",お:"o",か:"ka",き:"ki",く:"ku",け:"ke",こ:"ko",
    さ:"sa",し:"shi",す:"su",せ:"se",そ:"so",た:"ta",ち:"chi",つ:"tsu",て:"te",と:"to",
    な:"na",に:"ni",ぬ:"nu",ね:"ne",の:"no",は:"ha",ひ:"hi",ふ:"fu",へ:"he",ほ:"ho",
    ま:"ma",み:"mi",む:"mu",め:"me",も:"mo",や:"ya",ゆ:"yu",よ:"yo",ら:"ra",り:"ri",
    る:"ru",れ:"re",ろ:"ro",わ:"wa",を:"o",ん:"n",が:"ga",ぎ:"gi",ぐ:"gu",げ:"ge",
    ご:"go",ざ:"za",じ:"ji",ず:"zu",ぜ:"ze",ぞ:"zo",だ:"da",ぢ:"ji",づ:"zu",で:"de",
    ど:"do",ば:"ba",び:"bi",ぶ:"bu",べ:"be",ぼ:"bo",ぱ:"pa",ぴ:"pi",ぷ:"pu",ぺ:"pe",
    ぽ:"po",ぁ:"a",ぃ:"i",ぅ:"u",ぇ:"e",ぉ:"o",ー:"",
  };
  const digraph = {
    きゃ:"kya",きゅ:"kyu",きょ:"kyo",しゃ:"sha",しゅ:"shu",しょ:"sho",
    ちゃ:"cha",ちゅ:"chu",ちょ:"cho",にゃ:"nya",にゅ:"nyu",にょ:"nyo",
    ひゃ:"hya",ひゅ:"hyu",ひょ:"hyo",みゃ:"mya",みゅ:"myu",みょ:"myo",
    りゃ:"rya",りゅ:"ryu",りょ:"ryo",ぎゃ:"gya",ぎゅ:"gyu",ぎょ:"gyo",
    じゃ:"ja",じゅ:"ju",じょ:"jo",びゃ:"bya",びゅ:"byu",びょ:"byo",
    ぴゃ:"pya",ぴゅ:"pyu",ぴょ:"pyo",
  };
  let out = "";
  for (let i = 0; i < s.length; i++) {
    const ch = s[i], next = s[i + 1] || "";
    if (ch === "っ") {
      const pair = s.slice(i + 1, i + 3);
      const nxt = digraph[pair] || mono[s[i + 1]] || "";
      if (nxt) out += nxt[0];
      continue;
    }
    const pair2 = ch + next;
    if (digraph[pair2]) { out += digraph[pair2]; i++; continue; }
    out += mono[ch] ?? ch;
  }
  return out;
}

async function fetchKanjiVGPaths(kanji) {
  const hex = codepointHex(kanji);
  const url = `https://kanjivg.tagaini.net/kanjivg/kanji/${hex}.svg`;
  const res = await fetch(url, { cache: "force-cache" });
  if (!res.ok) throw new Error(`KanjiVG fetch failed: ${res.status}`);
  const text = await res.text();
  const doc = new DOMParser().parseFromString(text, "image/svg+xml");
  const svg = doc.querySelector("svg");
  const viewBox = svg?.getAttribute("viewBox") || "0 0 109 109";
  const paths = Array.from(doc.querySelectorAll("path")).map((p) => p.getAttribute("d")).filter(Boolean);
  return { viewBox, paths };
}

function samplePathPoints(d, samples = 24) {
  const svgNS = "http://www.w3.org/2000/svg";
  const p = document.createElementNS(svgNS, "path");
  p.setAttribute("d", d);
  const len = p.getTotalLength();
  if (!isFinite(len) || len <= 0) return [];
  const pts = [];
  for (let i = 0; i <= samples; i++) {
    const pt = p.getPointAtLength((len * i) / samples);
    pts.push({ x: pt.x, y: pt.y });
  }
  return pts;
}

function glassShadow(dark) {
  return dark ? "0 18px 60px rgba(0,0,0,0.55)" : "0 18px 60px rgba(29, 12, 18, 0.12)";
}

/* -----------------------------
   PROGRESS STORAGE
----------------------------- */
const SET_SIZE = 20;

function getStorageKey(level) { return `kanji_progress_${level}`; }

function loadProgress(level) {
  try {
    const raw = localStorage.getItem(getStorageKey(level));
    return raw ? JSON.parse(raw) : { learned: {}, setIndex: 0 };
  } catch { return { learned: {}, setIndex: 0 }; }
}

function saveProgress(level, progress) {
  try { localStorage.setItem(getStorageKey(level), JSON.stringify(progress)); } catch {}
}

function makeSets(deck, size = SET_SIZE) {
  const sets = [];
  for (let i = 0; i < deck.length; i += size) {
    sets.push(deck.slice(i, i + size));
  }
  return sets;
}

/* ===========================
   SET SELECTION SCREEN
=========================== */
function SetSelectScreen({ deck, level, theme, onSelectSet, onBack }) {
  const sets = useMemo(() => makeSets(deck), [deck]);
  const [progress, setProgress] = useState(() => loadProgress(level));

  function getSetStats(setItems) {
    const learned = setItems.filter(k => progress.learned[k.kanji]).length;
    return { learned, total: setItems.length, pct: Math.round((learned / setItems.length) * 100) };
  }

  function resetAll() {
    const fresh = { learned: {}, setIndex: 0 };
    saveProgress(level, fresh);
    setProgress(fresh);
  }

  const totalLearned = Object.keys(progress.learned).length;
  const totalAll = deck.length;

  return (
    <div style={{ animation: "fadeIn 0.2s ease" }}>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}`}</style>

      {/* Overall progress */}
      <div style={{
        borderRadius: 20, border: `1px solid ${theme.border}`,
        background: theme.glass, backdropFilter: "blur(18px)",
        padding: "16px 18px", marginBottom: 16,
        boxShadow: theme.glowSoft,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <div style={{ fontWeight: 900, color: theme.text, fontSize: 15 }}>Overall Progress</div>
          <button onClick={resetAll} style={{
            border: `1px solid ${theme.border}`, background: theme.glass2, color: theme.muted,
            borderRadius: 999, padding: "5px 12px", cursor: "pointer", fontWeight: 900, fontSize: 11,
            backdropFilter: "blur(14px)",
          }}>Reset All</button>
        </div>
        <div style={{ height: 10, background: theme.track, borderRadius: 999, overflow: "hidden", border: `1px solid ${theme.border}` }}>
          <div style={{ height: "100%", width: `${Math.round((totalLearned / totalAll) * 100)}%`, background: theme.accent, borderRadius: 999, transition: "width 400ms ease" }} />
        </div>
        <div style={{ marginTop: 8, fontSize: 13, fontWeight: 900, color: theme.muted }}>
          {totalLearned} / {totalAll} kanji marked learned
        </div>
      </div>

      {/* Set cards */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {sets.map((setItems, idx) => {
          const stats = getSetStats(setItems);
          const isComplete = stats.learned === stats.total;
          return (
            <button key={idx} onClick={() => onSelectSet(idx, setItems)}
              style={{
                display: "flex", alignItems: "center", gap: 14, padding: "16px 18px",
                borderRadius: 18, border: `1.5px solid ${isComplete ? theme.accent + "55" : theme.border}`,
                background: isComplete
                  ? (theme.isDark ? "rgba(214,52,71,0.08)" : "rgba(214,52,71,0.05)")
                  : theme.glass,
                backdropFilter: "blur(18px)", cursor: "pointer", textAlign: "left",
                boxShadow: isComplete ? theme.glow : theme.glowSoft,
                transition: "all 160ms ease",
              }}>
              {/* Set icon */}
              <div style={{
                width: 48, height: 48, borderRadius: 14, flexShrink: 0,
                background: isComplete ? theme.accent : theme.glass2,
                border: `1px solid ${theme.border}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 20, fontWeight: 900, color: isComplete ? "white" : theme.text,
              }}>
                {isComplete ? "✓" : `${idx + 1}`}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                  <span style={{ fontWeight: 900, color: theme.text, fontSize: 15 }}>Set {idx + 1}</span>
                  {isComplete && <span style={{ fontSize: 10, fontWeight: 900, background: theme.accent, color: "white", borderRadius: 999, padding: "2px 8px" }}>Complete!</span>}
                </div>
                {/* Mini kanji preview */}
                <div style={{ fontSize: 16, letterSpacing: 2, color: theme.muted, marginBottom: 6, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                  {setItems.slice(0, 8).map(k => k.kanji).join(" ")}
                  {setItems.length > 8 && " …"}
                </div>
                {/* Progress bar */}
                <div style={{ height: 6, background: theme.track, borderRadius: 999, overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${stats.pct}%`, background: isComplete ? theme.accent : theme.accent + "99", borderRadius: 999, transition: "width 400ms ease" }} />
                </div>
                <div style={{ marginTop: 5, fontSize: 11, fontWeight: 900, color: theme.faint }}>
                  {stats.learned}/{stats.total} learned
                </div>
              </div>
              <div style={{ fontSize: 18, color: theme.faint }}>→</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* ===========================
   SET STUDY VIEW
=========================== */
function SetStudyView({ setItems, setIdx, level, deck, theme, showEnglish, sound, onBack }) {
  const [progress, setProgress] = useState(() => loadProgress(level));
  const [studyTab, setStudyTab] = useState("cards"); // cards | quiz | all
  const [cardIndex, setCardIndex] = useState(0);
  const [cardFlipped, setCardFlipped] = useState(false);
  const [quizQueue, setQuizQueue] = useState(() => shuffle(setItems));
  const [quizPos, setQuizPos] = useState(0);
  const [quizScore, setQuizScore] = useState(0);
  const [quizDone, setQuizDone] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);

  function speakJP(kana) {
    if (!sound || !kana || !("speechSynthesis" in window)) return;
    const vs = window.speechSynthesis.getVoices?.() || [];
    const jp = vs.find((v) => (v.lang || "").toLowerCase().startsWith("ja"));
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(kana);
    u.lang = "ja-JP"; if (jp) u.voice = jp;
    window.speechSynthesis.speak(u);
  }

  function markLearned(kanji, val) {
    const next = { ...progress, learned: { ...progress.learned, [kanji]: val } };
    setProgress(next);
    saveProgress(level, next);
  }

  const learnedInSet = setItems.filter(k => progress.learned[k.kanji]).length;
  const currentCard = setItems[cardIndex];
  const quizItem = quizQueue[quizPos];

  const quizChoices = useMemo(() => {
    if (!quizItem) return [];
    const others = shuffle(deck.filter(k => k.kanji !== quizItem.kanji)).slice(0, 3);
    return shuffle([quizItem, ...others]).map(x => ({
      key: x.kanji, kanji: x.kanji, meaning: x.meaning, correct: x.kanji === quizItem.kanji,
    }));
  }, [quizItem, deck]);

  function startQuiz() {
    setQuizQueue(shuffle(setItems)); setQuizPos(0); setQuizScore(0); setQuizDone(false); setShowAnswer(false);
  }

  const pill = (active) => ({
    display: "inline-flex", alignItems: "center", gap: 6, borderRadius: 999,
    padding: "9px 16px", fontWeight: 900, cursor: "pointer",
    border: `1px solid ${theme.border}`,
    background: active ? theme.accent : theme.glass,
    color: active ? "white" : theme.text,
    boxShadow: active ? theme.glow : theme.glowSoft,
    backdropFilter: "blur(14px)",
  });

  const glassCard = {
    background: theme.card, borderRadius: 22, border: `1px solid ${theme.border}`,
    boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", overflow: "hidden",
  };

  return (
    <div style={{ animation: "fadeIn 0.2s ease" }}>
      {/* Set header */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <button onClick={onBack} style={{
            border: `1px solid ${theme.border}`, background: theme.glass, borderRadius: 999,
            padding: "7px 14px", fontWeight: 900, cursor: "pointer", color: theme.text,
            backdropFilter: "blur(14px)", fontSize: 13,
          }}>← Sets</button>
          <div>
            <div style={{ fontWeight: 900, color: theme.text, fontSize: 16 }}>Set {setIdx + 1}</div>
            <div style={{ fontSize: 12, color: theme.muted, fontWeight: 700 }}>{learnedInSet}/{setItems.length} learned</div>
          </div>
        </div>
        {/* Set progress bar */}
        <div style={{ height: 7, background: theme.track, borderRadius: 999, overflow: "hidden", border: `1px solid ${theme.border}` }}>
          <div style={{ height: "100%", width: `${Math.round((learnedInSet / setItems.length) * 100)}%`, background: theme.accent, borderRadius: 999, transition: "width 400ms ease" }} />
        </div>
      </div>

      {/* Sub tabs */}
      <div style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
        {[["cards","🃏 Cards"],["quiz","🧠 Quiz"],["all","🗂️ View All"]].map(([k, label]) => (
          <button key={k} onClick={() => setStudyTab(k)} style={pill(studyTab === k)}>{label}</button>
        ))}
      </div>

      {/* CARDS TAB */}
      {studyTab === "cards" && (
        <div style={{ ...glassCard, padding: 18 }}>
          {/* Flashcard */}
          <div
            onClick={() => setCardFlipped(f => !f)}
            style={{
              borderRadius: 20, border: `1.5px solid ${theme.border}`,
              background: theme.isDark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.85)",
              padding: "36px 20px", textAlign: "center", cursor: "pointer",
              boxShadow: glassShadow(theme.isDark), backdropFilter: "blur(20px)",
              minHeight: 200, display: "flex", flexDirection: "column",
              alignItems: "center", justifyContent: "center", gap: 12,
              userSelect: "none", marginBottom: 16, transition: "transform 120ms ease",
            }}>
            <div style={{ fontSize: 80, fontWeight: 900, lineHeight: 1 }}>{currentCard?.kanji}</div>
            {cardFlipped ? (
              <div style={{ animation: "fadeIn 0.15s ease" }}>
                <div style={{ fontWeight: 900, color: theme.accent, fontSize: 20 }}>{currentCard?.meaning}</div>
                <div style={{ color: theme.muted, fontWeight: 900, marginTop: 6 }}>{currentCard?.readingKana || "—"}</div>
                {showEnglish && currentCard?.readingKana && (
                  <div style={{ color: theme.faint, fontSize: 13, marginTop: 4 }}>{kanaToRomaji(currentCard.readingKana)}</div>
                )}
                <div style={{ marginTop: 10, color: theme.faint, fontSize: 12 }}>{currentCard?.story}</div>
              </div>
            ) : (
              <div style={{ color: theme.faint, fontSize: 13, fontWeight: 700 }}>Tap to reveal</div>
            )}
          </div>

          {/* Mark learned */}
          {cardFlipped && (
            <div style={{ display: "flex", gap: 10, justifyContent: "center", marginBottom: 16, animation: "fadeIn 0.15s ease" }}>
              <button onClick={() => { markLearned(currentCard.kanji, false); }}
                style={{ ...pill(progress.learned[currentCard?.kanji] === false), background: progress.learned[currentCard?.kanji] === false ? "#ef4444" : theme.glass, color: progress.learned[currentCard?.kanji] === false ? "white" : theme.text }}>
                😕 Still Learning
              </button>
              <button onClick={() => { markLearned(currentCard.kanji, true); speakJP(currentCard.readingKana); }}
                style={{ ...pill(progress.learned[currentCard?.kanji] === true), background: progress.learned[currentCard?.kanji] === true ? "#22c55e" : theme.glass, color: progress.learned[currentCard?.kanji] === true ? "white" : theme.text }}>
                ✓ Learned!
              </button>
            </div>
          )}

          {/* Navigation */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
            <button onClick={() => { setCardIndex(i => Math.max(0, i - 1)); setCardFlipped(false); }}
              disabled={cardIndex === 0}
              style={{ ...pill(false), opacity: cardIndex === 0 ? 0.45 : 1, cursor: cardIndex === 0 ? "not-allowed" : "pointer" }}>
              ← Prev
            </button>
            <div style={{ fontWeight: 900, color: theme.muted, fontSize: 13 }}>{cardIndex + 1} / {setItems.length}</div>
            <button onClick={() => { setCardIndex(i => Math.min(setItems.length - 1, i + 1)); setCardFlipped(false); }}
              disabled={cardIndex >= setItems.length - 1}
              style={{ ...pill(true), opacity: cardIndex >= setItems.length - 1 ? 0.55 : 1, cursor: cardIndex >= setItems.length - 1 ? "not-allowed" : "pointer" }}>
              Next →
            </button>
          </div>

          {/* Shuffle */}
          <div style={{ textAlign: "center", marginTop: 12 }}>
            <button onClick={() => { setCardIndex(0); setCardFlipped(false); }}
              style={{ border: "none", background: "transparent", color: theme.muted, fontWeight: 900, cursor: "pointer", fontSize: 13 }}>
              ↩ Start Over
            </button>
          </div>
        </div>
      )}

      {/* QUIZ TAB */}
      {studyTab === "quiz" && (
        <div style={{ ...glassCard, padding: 18 }}>
          {quizDone ? (
            <div style={{ textAlign: "center", padding: "24px 16px" }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>🎉</div>
              <div style={{ fontSize: 22, fontWeight: 900, color: theme.text, marginBottom: 8 }}>Quiz Complete!</div>
              <div style={{ fontSize: 16, fontWeight: 900, color: theme.muted, marginBottom: 20 }}>
                Score: {quizScore} / {quizQueue.length} ({Math.round((quizScore / quizQueue.length) * 100)}%)
              </div>
              <button onClick={startQuiz} style={pill(true)}>Try Again</button>
            </div>
          ) : !quizItem ? (
            <div style={{ textAlign: "center", padding: 24 }}>
              <button onClick={startQuiz} style={pill(true)}>▶ Start Quiz</button>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div style={{ fontWeight: 900, color: theme.muted, fontSize: 13 }}>{quizPos + 1} / {quizQueue.length}</div>
                <div style={{ fontWeight: 900, color: theme.accent, fontSize: 13 }}>Score: {quizScore}</div>
              </div>
              {/* Progress */}
              <div style={{ height: 7, background: theme.track, borderRadius: 999, overflow: "hidden", marginBottom: 16 }}>
                <div style={{ height: "100%", width: `${Math.round((quizPos / quizQueue.length) * 100)}%`, background: theme.accent, borderRadius: 999, transition: "width 200ms ease" }} />
              </div>
              <div style={{ textAlign: "center", fontSize: 80, fontWeight: 900, marginBottom: 8 }}>{quizItem.kanji}</div>
              <div style={{ textAlign: "center", color: theme.muted, fontWeight: 900, fontSize: 13, marginBottom: 16 }}>Choose the meaning:</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                {quizChoices.map(c => (
                  <button key={c.key} onClick={() => {
                    if (c.correct) { setQuizScore(s => s + 1); speakJP(quizItem.readingKana); markLearned(quizItem.kanji, true); }
                    setShowAnswer(true);
                    setTimeout(() => {
                      setShowAnswer(false);
                      if (quizPos + 1 >= quizQueue.length) setQuizDone(true);
                      else setQuizPos(p => p + 1);
                    }, 700);
                  }}
                  disabled={showAnswer}
                  style={{
                    borderRadius: 16, padding: "18px 12px", fontWeight: 900, cursor: showAnswer ? "default" : "pointer",
                    border: `1.5px solid ${showAnswer ? (c.correct ? "#22c55e" : theme.border) : theme.border}`,
                    background: showAnswer ? (c.correct ? (theme.isDark ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.12)") : theme.glass2) : theme.glass2,
                    color: showAnswer && c.correct ? "#22c55e" : theme.text,
                    boxShadow: theme.glowSoft, backdropFilter: "blur(18px)",
                    fontSize: 14, transition: "all 120ms ease",
                  }}>
                    {c.meaning}
                  </button>
                ))}
              </div>
              <div style={{ textAlign: "center", marginTop: 14 }}>
                <button onClick={startQuiz} style={{ border: "none", background: "transparent", color: theme.faint, fontWeight: 900, cursor: "pointer", fontSize: 12 }}>↩ Restart</button>
              </div>
            </>
          )}
        </div>
      )}

      {/* VIEW ALL TAB */}
      {studyTab === "all" && (
        <div style={{ ...glassCard, padding: 14 }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 10 }}>
            {setItems.map(k => (
              <div key={k.kanji} style={{
                borderRadius: 16, padding: 14, border: `1px solid ${progress.learned[k.kanji] ? theme.accent + "55" : theme.border}`,
                background: progress.learned[k.kanji] ? (theme.isDark ? "rgba(214,52,71,0.08)" : "rgba(214,52,71,0.05)") : theme.glass,
                boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", textAlign: "center",
                position: "relative",
              }}>
                {progress.learned[k.kanji] && (
                  <div style={{ position: "absolute", top: 6, right: 8, fontSize: 12, color: theme.accent }}>✓</div>
                )}
                <div style={{ fontSize: 38, fontWeight: 900, marginBottom: 4 }}>{k.kanji}</div>
                {showEnglish && <div style={{ fontWeight: 900, color: theme.accent, fontSize: 13, marginBottom: 4 }}>{k.meaning}</div>}
                <div style={{ color: theme.muted, fontWeight: 900, fontSize: 12 }}>{k.readingKana || "—"}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* ===========================
   LEVEL SELECT SCREEN
=========================== */
function LevelSelect({ onSelect, theme, dark, setDark, sound, setSound }) {
  const [hovered, setHovered] = useState(null);

  const levels = [
    {
      key: "n5",
      label: "N5",
      sublabel: "JLPT Level 5",
      desc: "103 essential kanji",
      count: `${N5_KANJI_RAW.length} kanji`,
      badge: "Beginner",
      color: "#22c55e",
      glow: "0 12px 40px rgba(34,197,94,0.35)",
      icon: "🌱",
    },
    {
      key: "n4",
      label: "N4",
      sublabel: "JLPT Level 4",
      desc: "181 intermediate kanji",
      count: `${N4_KANJI_RAW.length} kanji`,
      badge: "Elementary",
      color: "#3b82f6",
      glow: "0 12px 40px rgba(59,130,246,0.35)",
      icon: "📚",
    },
  ];

  return (
    <div style={{
      minHeight: "100vh",
      background: dark
        ? "radial-gradient(ellipse at 30% 20%, rgba(214,52,71,0.08) 0%, #000 60%)"
        : "radial-gradient(ellipse at 30% 20%, rgba(214,52,71,0.06) 0%, #fff7f8 60%)",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "24px 16px",
      fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Noto Sans JP", sans-serif',
    }}>
      <div style={{ position: "absolute", top: 20, right: 20, display: "flex", gap: 14, alignItems: "center" }}>
        <button onClick={() => setSound(!sound)} style={{ border: `1px solid ${theme.border}`, background: theme.glass, borderRadius: 999, padding: "8px 12px", cursor: "pointer", color: theme.text, fontWeight: 900, backdropFilter: "blur(14px)", fontSize: 16 }}>{sound ? "🔊" : "🔇"}</button>
        <button onClick={() => setDark(!dark)} style={{ border: `1px solid ${theme.border}`, background: theme.glass, borderRadius: 999, padding: "8px 12px", cursor: "pointer", color: theme.text, fontWeight: 900, backdropFilter: "blur(14px)", fontSize: 16 }}>{dark ? "☀️" : "🌙"}</button>
      </div>

      <div style={{ textAlign: "center", marginBottom: 48 }}>
        <div style={{ fontSize: 52, marginBottom: 8 }}>漢字</div>
        <div style={{ fontSize: 36, fontWeight: 900, color: theme.text, letterSpacing: "-0.02em", lineHeight: 1, marginBottom: 10 }}>Kanji Learn</div>
        <div style={{ fontSize: 15, color: theme.muted, fontWeight: 700 }}>Choose your level to begin</div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16, width: "100%", maxWidth: 420 }}>
        {levels.map((lv) => {
          const isHov = hovered === lv.key;
          return (
            <button key={lv.key}
              onMouseEnter={() => setHovered(lv.key)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => onSelect(lv.key)}
              style={{
                display: "flex", alignItems: "center", gap: 20, padding: "22px 24px",
                borderRadius: 22, border: `1.5px solid ${isHov ? lv.color : theme.border}`,
                background: dark ? (isHov ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.06)") : (isHov ? "rgba(255,255,255,0.92)" : "rgba(255,255,255,0.72)"),
                boxShadow: isHov ? lv.glow : theme.glowSoft, backdropFilter: "blur(20px)",
                cursor: "pointer", textAlign: "left", transition: "all 160ms ease",
                transform: isHov ? "translateY(-2px)" : "none",
              }}>
              <div style={{ width: 56, height: 56, borderRadius: 18, background: isHov ? lv.color : (dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)"), display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, flexShrink: 0, transition: "background 160ms ease" }}>{lv.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 4 }}>
                  <span style={{ fontSize: 28, fontWeight: 900, color: isHov ? lv.color : theme.text, transition: "color 160ms ease" }}>{lv.label}</span>
                  <span style={{ fontSize: 12, fontWeight: 900, color: "white", background: lv.color, borderRadius: 999, padding: "2px 10px" }}>{lv.badge}</span>
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, color: theme.muted }}>{lv.sublabel}</div>
                <div style={{ fontSize: 12, color: theme.faint, marginTop: 3 }}>{lv.count}</div>
              </div>
              <div style={{ fontSize: 22, color: isHov ? lv.color : theme.faint, transition: "all 160ms ease", transform: isHov ? "translateX(4px)" : "none" }}>→</div>
            </button>
          );
        })}
      </div>

      <div style={{ marginTop: 40, fontSize: 12, color: theme.faint, fontWeight: 700 }}>
        Kanji Learn • JLPT Study App
      </div>
    </div>
  );
}

/* ===========================
   UI COMPONENTS
=========================== */
function Toggle({ checked, onChange, theme }) {
  return (
    <div role="switch" aria-checked={checked} tabIndex={0}
      onClick={() => onChange(!checked)}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onChange(!checked); }}
      style={{ width: 42, height: 24, borderRadius: 999, padding: 3, border: `1px solid ${theme.border}`, background: checked ? theme.accent : theme.glass, cursor: "pointer", display: "inline-flex", alignItems: "center", boxSizing: "border-box", boxShadow: theme.glowSoft, backdropFilter: "blur(14px)" }}>
      <div style={{ width: 18, height: 18, borderRadius: 999, background: checked ? "#fff" : theme.text, transform: `translateX(${checked ? 18 : 0}px)`, transition: "transform 130ms ease", boxShadow: "0 2px 12px rgba(0,0,0,0.18)" }} />
    </div>
  );
}

function ProgressBar({ value01, theme }) {
  const v = Math.max(0, Math.min(1, value01 || 0));
  return (
    <div style={{ height: 8, width: "100%", borderRadius: 999, background: theme.track, border: `1px solid ${theme.border}`, overflow: "hidden", boxShadow: theme.glowSoft, backdropFilter: "blur(14px)" }}>
      <div style={{ height: "100%", width: `${Math.round(v * 100)}%`, background: theme.accent, borderRadius: 999, transition: "width 180ms ease" }} />
    </div>
  );
}

function GlassModal({ open, title, children, onClose, theme }) {
  if (!open) return null;
  return (
    <div onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      style={{ position: "fixed", inset: 0, background: theme.overlay, zIndex: 99999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backdropFilter: "blur(8px)" }}>
      <div style={{ width: "min(520px, 100%)", borderRadius: 22, border: `1px solid ${theme.border}`, background: theme.modal, boxShadow: glassShadow(theme.isDark), overflow: "hidden", color: theme.text, backdropFilter: "blur(18px)" }}>
        <div style={{ padding: "14px 16px", fontWeight: 900, color: theme.text, background: theme.glass, borderBottom: `1px solid ${theme.border}`, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
          <div style={{ fontSize: 14 }}>{title}</div>
          <button onClick={onClose} style={{ border: `1px solid ${theme.border}`, background: theme.glass, color: theme.text, borderRadius: 999, padding: "8px 12px", fontWeight: 900, cursor: "pointer", boxShadow: theme.glowSoft }}>Close</button>
        </div>
        <div style={{ padding: 16 }}>{children}</div>
        <div style={{ padding: 16, borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "flex-end", gap: 10, background: theme.glass }}>
          <button onClick={onClose} style={{ borderRadius: 999, padding: "10px 16px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: theme.accent, color: "white", boxShadow: theme.glow }}>OK</button>
        </div>
      </div>
    </div>
  );
}

function pill(theme, { active = false } = {}) {
  return { display: "inline-flex", alignItems: "center", gap: 8, borderRadius: 999, padding: "10px 14px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: active ? theme.accent : theme.glass, color: active ? "white" : theme.text, boxShadow: active ? theme.glow : theme.glowSoft, backdropFilter: "blur(14px)", userSelect: "none" };
}

function smallGlassBtn(theme) {
  return { borderRadius: 14, padding: "10px 12px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: theme.glass, color: theme.text, boxShadow: theme.glowSoft, backdropFilter: "blur(16px)", userSelect: "none" };
}

function actionChip(theme, { active = false } = {}) {
  return { display: "inline-flex", alignItems: "center", gap: 8, borderRadius: 14, padding: "10px 12px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: active ? theme.glassStrong : theme.glass, color: theme.text, boxShadow: theme.glowSoft, backdropFilter: "blur(16px)", userSelect: "none" };
}

function miniRound(theme, { primary = false } = {}) {
  return { width: 36, height: 36, borderRadius: 999, border: `1px solid ${theme.border}`, background: primary ? theme.accent : theme.glass, color: primary ? "white" : theme.text, display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 900, cursor: "pointer", boxShadow: primary ? theme.glow : theme.glowSoft, backdropFilter: "blur(16px)" };
}

function KanjiPicker({ open, title, deck, selected, setSelected, theme, minSelected = 0, onMinFail, onClose }) {
  if (!open) return null;
  const selectedSet = new Set(selected);
  function apply(nextArr) {
    if (minSelected > 0 && nextArr.length < minSelected) { onMinFail?.(minSelected); return; }
    setSelected(nextArr);
  }
  return (
    <div style={{ marginTop: 14, border: `1px solid ${theme.border}`, borderRadius: 20, padding: 12, maxHeight: 320, overflow: "auto", background: theme.glass, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
        <div style={{ fontWeight: 900, color: theme.text, fontSize: 13 }}>{title}</div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button onClick={() => apply(deck.map((d) => d.kanji))} style={smallGlassBtn(theme)}>Select All</button>
          <button onClick={() => apply([])} style={smallGlassBtn(theme)}>Select None</button>
          <button onClick={onClose} style={{ ...smallGlassBtn(theme), background: theme.accent, color: "white" }}>Close</button>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10 }}>
        {deck.map((k) => {
          const checked = selectedSet.has(k.kanji);
          return (
            <button key={k.kanji}
              onClick={() => { const s = new Set(selected); if (s.has(k.kanji)) s.delete(k.kanji); else s.add(k.kanji); apply(Array.from(s)); }}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, padding: "10px 10px", borderRadius: 14, border: `1px solid ${theme.border}`, background: checked ? theme.selected : theme.glass2, color: theme.text, fontWeight: 900, cursor: "pointer", userSelect: "none", minHeight: 44, boxShadow: theme.glowSoft, backdropFilter: "blur(14px)" }}
              title={k.meaning}>
              <span style={{ width: 18, height: 18, borderRadius: 6, border: `2px solid ${checked ? theme.accent : theme.checkBorder}`, background: checked ? theme.accent : "transparent", display: "inline-block", boxShadow: checked ? theme.glow : "none" }} />
              <span style={{ fontSize: 18, lineHeight: "18px" }}>{k.kanji}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* ===========================
   MAIN PRACTICE VIEW
=========================== */
function PracticeView({ level, onBack, sound, setSound, dark, setDark }) {
  const rawData = level === "n5" ? N5_KANJI_RAW : N4_KANJI_RAW;
  const readings = level === "n5" ? N5_READINGS : N4_READINGS;
  const levelLabel = level === "n5" ? "N5" : "N4";
  const levelColor = level === "n5" ? "#22c55e" : "#3b82f6";

  // Main screen state: "sets" | "study"
  const [screen, setScreen] = useState("sets");
  const [activeSetIdx, setActiveSetIdx] = useState(null);
  const [activeSetItems, setActiveSetItems] = useState([]);

  const [tab, setTab] = useState("write");
  const [showEnglish, setShowEnglish] = useState(false);

  const theme = useMemo(() => {
    const accent = "#d63447";
    if (dark) {
      return {
        isDark: true, accent, bg: "#000000", bg2: "#070707",
        text: "#ffffff", muted: "rgba(255,255,255,0.78)", faint: "rgba(255,255,255,0.55)",
        border: "rgba(255,255,255,0.12)", track: "rgba(255,255,255,0.09)",
        glass: "rgba(255,255,255,0.08)", glass2: "rgba(255,255,255,0.06)",
        glassStrong: "rgba(255,255,255,0.12)", modal: "rgba(12,12,12,0.78)",
        overlay: "rgba(0,0,0,0.55)", card: "rgba(10,10,10,0.70)",
        selected: "rgba(255,255,255,0.12)", checkBorder: "rgba(255,255,255,0.35)",
        grid: "rgba(255,255,255,0.06)",
        glow: `0 12px 30px ${accent}33`, glowSoft: "0 12px 30px rgba(0,0,0,0.35)",
      };
    }
    return {
      isDark: false, accent, bg: "#fff7f8", bg2: "#fff0f3",
      text: "#2d1b1b", muted: "rgba(45,27,27,0.72)", faint: "rgba(45,27,27,0.52)",
      border: "rgba(214,52,71,0.16)", track: "rgba(255,255,255,0.55)",
      glass: "rgba(255,255,255,0.70)", glass2: "rgba(255,255,255,0.60)",
      glassStrong: "rgba(255,255,255,0.82)", modal: "rgba(255,255,255,0.74)",
      overlay: "rgba(18,10,12,0.32)", card: "rgba(255,255,255,0.72)",
      selected: "rgba(214,52,71,0.12)", checkBorder: "rgba(45,27,27,0.22)",
      grid: "rgba(214,52,71,0.04)",
      glow: `0 12px 30px ${accent}26`, glowSoft: "0 12px 30px rgba(29, 12, 18, 0.10)",
    };
  }, [dark]);

  const deck = useMemo(() => {
    const seen = new Set();
    const out = [];
    for (const r of rawData) {
      if (seen.has(r.kanji)) continue;
      seen.add(r.kanji);
      out.push({ kanji: r.kanji, meaning: r.meaning, story: r.story || "", readingKana: readings[r.kanji] || "" });
    }
    return out;
  }, [rawData, readings]);

  const ALL_KANJI = useMemo(() => deck.map((d) => d.kanji), [deck]);
  const allKanjiKey = useMemo(() => ALL_KANJI.join("|"), [ALL_KANJI]);

  function speakJP(kana) {
    if (!sound || !kana || !("speechSynthesis" in window)) return;
    const vs = window.speechSynthesis.getVoices?.() || [];
    const jp = vs.find((v) => (v.lang || "").toLowerCase().startsWith("ja"));
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(kana);
    u.lang = "ja-JP"; if (jp) u.voice = jp;
    window.speechSynthesis.speak(u);
  }

  const shell = {
    minHeight: "100vh",
    background: `linear-gradient(180deg, ${theme.bg} 0%, ${theme.bg2} 70%, ${theme.bg} 120%)`,
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Noto Sans JP", "Hiragino Kaku Gothic ProN", sans-serif',
    color: theme.text, paddingBottom: 40,
  };

  const pageWrap = { maxWidth: 520, margin: "0 auto", padding: "14px 14px 0" };
  const glassCard = {
    background: theme.card, borderRadius: 22, border: `1px solid ${theme.border}`,
    boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", overflow: "hidden",
  };
  const divider = { height: 1, background: theme.isDark ? "rgba(255,255,255,0.10)" : "rgba(214,52,71,0.18)", margin: "14px 0" };

  const [popup, setPopup] = useState({ open: false, title: "", body: null, onClose: null });
  function openPopup(title, body) { setPopup({ open: true, title, body, onClose: null }); }
  function closePopup() { setPopup((p) => ({ ...p, open: false, onClose: null })); }

  /* WRITE */
  const [writePickerOpen, setWritePickerOpen] = useState(false);
  const [selectedKanji, setSelectedKanji] = useState(() => [...ALL_KANJI]);
  const [writeOrder, setWriteOrder] = useState(() => [...ALL_KANJI]);
  const [writeIndex, setWriteIndex] = useState(0);
  const [writeDone, setWriteDone] = useState(false);
  const [showStrokeHint, setShowStrokeHint] = useState(true);

  useEffect(() => {
    setSelectedKanji([...ALL_KANJI]);
    setWriteOrder([...ALL_KANJI]);
    setWriteIndex(0);
    setWriteDone(false);
  }, [ALL_KANJI, allKanjiKey]);

  const selectedDeck = useMemo(() => deck.filter((d) => selectedKanji.includes(d.kanji)), [deck, selectedKanji]);
  const currentWriteKanji = writeOrder[writeIndex] || selectedDeck[0]?.kanji;
  const writeItem = selectedDeck.find((d) => d.kanji === currentWriteKanji) || selectedDeck[0];

  function shuffleWrite() { if (writeOrder.length < 2) return; setWriteDone(false); setWriteOrder((prev) => shuffle(prev)); setWriteIndex(0); }
  function goPrevWrite() { setWriteDone(false); setWriteIndex((i) => Math.max(0, i - 1)); }
  function goNextWrite() { setWriteDone(false); setWriteIndex((i) => Math.min(writeOrder.length - 1, i + 1)); }
  const writeProgress = useMemo(() => Math.min(writeIndex, writeOrder.length) / Math.max(1, writeOrder.length), [writeIndex, writeOrder.length]);

  function practiceWriteAgain() {
    const order = writeOrder.length ? [...writeOrder] : [...selectedKanji];
    setWriteOrder(order.length ? order : [...ALL_KANJI]);
    setWriteIndex(0); setWriteDone(false); setStrokeIndex(0); setUserStrokes([]); clearCanvas();
  }

  /* KanjiVG */
  const [vg, setVg] = useState({});
  const [vgErr, setVgErr] = useState("");
  useEffect(() => {
    let cancelled = false; setVgErr("");
    (async () => {
      try {
        if (!writeItem?.kanji || vg[writeItem.kanji]) return;
        const data = await fetchKanjiVGPaths(writeItem.kanji);
        if (!cancelled) setVg((p) => ({ ...p, [writeItem.kanji]: data }));
      } catch (e) { if (!cancelled) setVgErr(String(e?.message || e)); }
    })();
    return () => { cancelled = true; };
  }, [writeItem?.kanji, vg]);

  /* Drawing */
  const padRef = useRef(null);
  const canvasRef = useRef(null);
  const [strokeIndex, setStrokeIndex] = useState(0);
  const [userStrokes, setUserStrokes] = useState([]);
  const drawingRef = useRef({ active: false, pointerId: null, points: [] });
  const PAD = 380;

  function lockScroll(lock) {
    document.documentElement.style.overscrollBehavior = lock ? "none" : "";
    document.body.style.overscrollBehavior = lock ? "none" : "";
    document.body.style.touchAction = lock ? "none" : "";
  }
  function clearCanvas() { const c = canvasRef.current; if (!c) return; c.getContext("2d").clearRect(0, 0, c.width, c.height); }
  function redrawCanvas(strokes) {
    const c = canvasRef.current; if (!c) return;
    const ctx = c.getContext("2d"); ctx.clearRect(0, 0, c.width, c.height);
    for (const s of strokes) {
      ctx.strokeStyle = theme.accent; ctx.lineWidth = 14; ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.beginPath(); s.points.forEach((p, i) => { if (i === 0) ctx.moveTo(p.x, p.y); else ctx.lineTo(p.x, p.y); }); ctx.stroke();
    }
  }
  function resetWrite() { setStrokeIndex(0); setUserStrokes([]); clearCanvas(); }
  function getPadPoint(evt) {
    const pad = padRef.current, c = canvasRef.current; if (!pad || !c) return { x: 0, y: 0 };
    const r = pad.getBoundingClientRect();
    return { x: (evt.clientX - r.left) * (c.width / r.width), y: (evt.clientY - r.top) * (c.height / r.height) };
  }
  function validateStroke(userPts, dPath, padSize, viewBox) {
    if (!dPath || !userPts || userPts.length < 6) return { ok: false };
    const vb = (viewBox || "0 0 109 109").split(" ").map(Number);
    const vbW = vb[2] || 109, vbH = vb[3] || 109;
    const samples = samplePathPoints(dPath, 24); if (samples.length < 2) return { ok: false };
    const start = samples[0], end = samples[samples.length - 1];
    const tS = { x: (start.x / vbW) * padSize, y: (start.y / vbH) * padSize };
    const tE = { x: (end.x / vbW) * padSize, y: (end.y / vbH) * padSize };
    const uS = userPts[0], uE = userPts[userPts.length - 1];
    const tol = padSize * 0.12;
    if (dist(uS, tS) > tol || dist(uE, tE) > tol) return { ok: false };
    if (angleDiff(angle(uS, uE), angle(tS, tE)) > Math.PI / 3) return { ok: false };
    return { ok: true };
  }
  function onPointerDown(e) {
    if (tab !== "write" || writeDone) return;
    const pad = padRef.current, c = canvasRef.current; if (!pad || !c) return;
    pad.setPointerCapture(e.pointerId);
    drawingRef.current = { active: true, pointerId: e.pointerId, points: [] };
    lockScroll(true); e.preventDefault();
    const p = getPadPoint(e); drawingRef.current.points.push(p);
    const ctx = c.getContext("2d");
    ctx.strokeStyle = theme.accent; ctx.lineWidth = 14; ctx.lineCap = "round"; ctx.lineJoin = "round";
    ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x + 0.001, p.y + 0.001); ctx.stroke();
  }
  function onPointerMove(e) {
    if (!drawingRef.current.active || drawingRef.current.pointerId !== e.pointerId) return;
    const c = canvasRef.current; if (!c) return; e.preventDefault();
    const p = getPadPoint(e), pts = drawingRef.current.points;
    const prev = pts[pts.length - 1]; pts.push(p);
    const ctx = c.getContext("2d");
    ctx.strokeStyle = theme.accent; ctx.lineWidth = 14; ctx.lineCap = "round"; ctx.lineJoin = "round";
    ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(p.x, p.y); ctx.stroke();
  }
  function finishStroke(e) {
    if (!drawingRef.current.active || drawingRef.current.pointerId !== e.pointerId) return;
    e.preventDefault(); lockScroll(false); drawingRef.current.active = false;
    const pts = drawingRef.current.points; drawingRef.current.points = [];
    const data = vg[writeItem.kanji];
    const check = validateStroke(pts, data?.paths?.[strokeIndex], canvasRef.current?.width || PAD, data?.viewBox);
    if (!check.ok) { redrawCanvas(userStrokes); return; }
    const nextUser = [...userStrokes, { points: pts }];
    setUserStrokes(nextUser); redrawCanvas(nextUser);
    const total = data?.paths?.length ?? 0;
    if (strokeIndex + 1 >= total) {
      speakJP(writeItem.readingKana);
      setTimeout(() => {
        const isLast = writeIndex >= writeOrder.length - 1;
        setStrokeIndex(0); setUserStrokes([]); clearCanvas();
        if (isLast) { setWriteDone(true); return; }
        setWriteIndex((i) => Math.min(writeOrder.length - 1, i + 1));
      }, 450);
    } else { setStrokeIndex((s) => s + 1); }
  }
  useEffect(() => { setStrokeIndex(0); setUserStrokes([]); clearCanvas(); }, [writeItem?.kanji]);
  useEffect(() => { return () => lockScroll(false); }, []);

  /* LEARN */
  const [learnPickerOpen, setLearnPickerOpen] = useState(false);
  const [selectedLearnKanji, setSelectedLearnKanji] = useState(() => [...ALL_KANJI]);
  const learnPoolDeck = useMemo(() => deck.filter((d) => selectedLearnKanji.includes(d.kanji)), [deck, selectedLearnKanji]);
  const [learnQueue, setLearnQueue] = useState(() => shuffle(deck));
  const [learnStartSize, setLearnStartSize] = useState(() => deck.length);

  function resetLearn() { const q = shuffle(learnPoolDeck.length ? learnPoolDeck : deck); setLearnQueue(q); setLearnStartSize(q.length); }
  function shuffleLearn() { resetLearn(); }
  useEffect(() => {
    if (tab !== "learn") return;
    const base = learnPoolDeck.length ? learnPoolDeck : deck;
    setLearnQueue((q) => (q && q.length ? q : shuffle(base)));
    setLearnStartSize(base.length);
  }, [tab, deck, learnPoolDeck]);

  const learnItem = learnQueue[0];
  const learnChoices = useMemo(() => {
    if (!learnItem) return [];
    const base = learnPoolDeck.length ? learnPoolDeck : deck;
    const others = shuffle(base.filter((k) => k.kanji !== learnItem.kanji)).slice(0, 3);
    return shuffle([learnItem, ...others]).map((x) => ({
      key: x.kanji, reading: x.readingKana || "—", romaji: kanaToRomaji(x.readingKana || ""), correct: x.kanji === learnItem.kanji,
    }));
  }, [learnItem, deck, learnPoolDeck]);

  function answerLearn(choice) {
    if (!learnItem) return;
    speakJP(choice.reading);
    const ok = choice.correct;
    const correctReading = learnItem.readingKana || "—";
    openPopup(ok ? "✅ Correct" : "❌ Wrong",
      <div style={{ fontWeight: 900, color: theme.text, lineHeight: 1.45 }}>
        <div style={{ fontSize: 18 }}>Meaning: <span style={{ color: theme.accent }}>{learnItem.meaning}</span></div>
        <div style={{ marginTop: 6, fontSize: 18 }}>Kanji: <span style={{ fontWeight: 900 }}>{learnItem.kanji}</span></div>
        <div style={{ marginTop: 10 }}>Correct reading: <span style={{ fontWeight: 900, color: theme.accent }}>{correctReading}</span>{showEnglish && <div style={{ marginTop: 4, color: theme.muted, fontWeight: 900, fontSize: 13 }}>{kanaToRomaji(correctReading)}</div>}</div>
        <div style={{ marginTop: 14, color: theme.faint, fontWeight: 800, fontSize: 12 }}>(Press OK to continue)</div>
      </div>
    );
    setPopup((p) => ({ ...p, onClose: () => { closePopup(); setLearnQueue((q) => { if (!q.length) return q; return ok ? q.slice(1) : [...q.slice(1), q[0]]; }); } }));
  }

  const learnProgress = useMemo(() => {
    const total = Math.max(1, learnStartSize || learnPoolDeck.length || deck.length);
    return Math.max(0, total - learnQueue.length) / total;
  }, [learnStartSize, learnQueue.length, deck.length, learnPoolDeck.length]);

  /* TEST */
  const allowedCounts = useMemo(() => {
    const max = Math.max(1, deck.length);
    const base = [5, 10, 15, 20, 25, 30, 40, 50, 75, 100, 150, 200].filter((n) => n <= max);
    if (!base.includes(max)) base.push(max);
    return base.sort((a, b) => a - b);
  }, [deck.length]);

  const [testCount, setTestCount] = useState(25);
  const [testActive, setTestActive] = useState(false);
  const [testItems, setTestItems] = useState([]);
  const [testPos, setTestPos] = useState(0);
  const [testScore, setTestScore] = useState(0);

  function startTest() {
    const n = Math.max(1, Math.min(deck.length, Number(testCount) || 25));
    setTestItems(shuffle(deck).slice(0, n)); setTestPos(0); setTestScore(0); setTestActive(true);
  }
  function resetTest() { setTestActive(false); setTestItems([]); setTestPos(0); setTestScore(0); }

  const testItem = testItems[testPos];
  const testChoices = useMemo(() => {
    if (!testItem) return [];
    const others = shuffle(deck.filter((k) => k.kanji !== testItem.kanji)).slice(0, 3);
    return shuffle([testItem, ...others]).map((x) => ({ key: x.kanji, reading: x.readingKana || "—", romaji: kanaToRomaji(x.readingKana || ""), correct: x.kanji === testItem.kanji }));
  }, [testItem, deck]);

  function answerTest(choice) {
    if (!testItem) return;
    speakJP(choice.reading);
    const ok = choice.correct;
    const correctReading = testItem.readingKana || "—";
    if (ok) setTestScore((s) => s + 1);
    openPopup(ok ? "✅ Correct" : "❌ Wrong",
      <div style={{ fontWeight: 900, color: theme.text, lineHeight: 1.45 }}>
        <div style={{ fontSize: 18 }}>Meaning: <span style={{ color: theme.accent }}>{testItem.meaning}</span></div>
        <div style={{ marginTop: 6, fontSize: 18 }}>Kanji: <span style={{ fontWeight: 900 }}>{testItem.kanji}</span></div>
        <div style={{ marginTop: 10 }}>Correct reading: <span style={{ fontWeight: 900, color: theme.accent }}>{correctReading}</span>{showEnglish && <div style={{ marginTop: 4, color: theme.muted, fontWeight: 900, fontSize: 13 }}>{kanaToRomaji(correctReading)}</div>}</div>
        <div style={{ marginTop: 14, color: theme.faint, fontWeight: 800, fontSize: 12 }}>(Press OK to continue)</div>
      </div>
    );
    setPopup((p) => ({ ...p, onClose: () => { closePopup(); setTestPos((pos) => pos + 1); } }));
  }

  const testProgress = useMemo(() => (!testActive || !testItems.length) ? 0 : Math.min(1, testPos / testItems.length), [testActive, testPos, testItems.length]);

  const vgData = writeItem ? vg[writeItem.kanji] : null;
  const totalStrokes = vgData?.paths?.length ?? 0;

  // Progress for the level
  const [levelProgress, setLevelProgress] = useState(() => loadProgress(level));
  const totalLearned = Object.keys(levelProgress.learned).length;

  return (
    <div style={shell} ref={() => { document.body.style.margin = "0"; document.body.style.padding = "0"; }}>
      <GlassModal open={popup.open} title={popup.title} theme={theme} onClose={popup.onClose || closePopup}>
        {popup.body}
      </GlassModal>

      <div style={pageWrap}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button onClick={onBack} style={{ border: `1px solid ${theme.border}`, background: theme.glass, borderRadius: 999, padding: "8px 14px", fontWeight: 900, cursor: "pointer", color: theme.text, backdropFilter: "blur(14px)", boxShadow: theme.glowSoft, fontSize: 13 }}>← Back</button>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ fontSize: 20, fontWeight: 900, color: theme.accent, lineHeight: 1 }}>Kanji Learn</div>
                <span style={{ fontSize: 11, fontWeight: 900, color: "white", background: levelColor, borderRadius: 999, padding: "2px 8px" }}>{levelLabel}</span>
              </div>
              <div style={{ fontSize: 11, color: theme.faint, fontWeight: 700, marginTop: 2 }}>{totalLearned}/{deck.length} learned</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 16, color: theme.text }}>🔊</span>
              <Toggle checked={sound} onChange={setSound} theme={theme} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 900, color: theme.text }}>EN</span>
              <Toggle checked={showEnglish} onChange={setShowEnglish} theme={theme} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 16, color: theme.text }}>{dark ? "🌙" : "☀️"}</span>
              <Toggle checked={dark} onChange={setDark} theme={theme} />
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "4px 0 2px", flexWrap: "wrap" }}>
          {[["sets","Sets","📦"],["write","Write","✍️"],["learn","Learn","📖"],["test","Test","🧪"],["all","All","🗂️"]].map(([key, label, icon]) => (
            tab === key
              ? <button key={key} onClick={() => setTab(key)} style={pill(theme, { active: true })}><span>{icon}</span><span>{label}</span></button>
              : <button key={key} onClick={() => setTab(key)} style={{ border: "none", background: "transparent", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 8px", color: theme.muted, fontWeight: 900 }}>
                  <span style={{ opacity: 0.9 }}>{icon}</span><span>{label}</span>
                </button>
          ))}
        </div>

        <div style={{ marginTop: 12 }}>

          {/* SETS TAB */}
          {tab === "sets" && (
            screen === "study" ? (
              <SetStudyView
                setItems={activeSetItems}
                setIdx={activeSetIdx}
                level={level}
                deck={deck}
                theme={theme}
                showEnglish={showEnglish}
                sound={sound}
                onBack={() => { setScreen("sets"); setLevelProgress(loadProgress(level)); }}
              />
            ) : (
              <SetSelectScreen
                deck={deck}
                level={level}
                theme={theme}
                onSelectSet={(idx, items) => { setActiveSetIdx(idx); setActiveSetItems(items); setScreen("study"); }}
                onBack={() => setTab("sets")}
              />
            )
          )}

          {/* WRITE TAB */}
          {tab === "write" && (
            <div style={{ ...glassCard, padding: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <button onClick={() => setWritePickerOpen((o) => !o)} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>▦</span><span>Select</span></button>
                  <button onClick={shuffleWrite} disabled={writeOrder.length < 2} style={{ ...actionChip(theme), opacity: writeOrder.length < 2 ? 0.55 : 1, cursor: writeOrder.length < 2 ? "not-allowed" : "pointer" }}><span style={{ opacity: 0.9 }}>⤮</span><span>Shuffle</span></button>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 900, color: theme.text }}>Hint</div>
                  <Toggle checked={showStrokeHint} onChange={setShowStrokeHint} theme={theme} />
                </div>
              </div>

              <KanjiPicker open={writePickerOpen} title="Select Kanji" deck={deck}
                selected={selectedKanji}
                setSelected={(v) => { setSelectedKanji(v); setWriteOrder(Array.isArray(v) ? v : []); setWriteIndex(0); setWriteDone(false); }}
                theme={theme} minSelected={1} onMinFail={() => {}}
                onClose={() => setWritePickerOpen(false)} />

              {!writeItem || selectedDeck.length === 0 ? (
                <div style={{ padding: 36, textAlign: "center", fontWeight: 900, color: theme.muted }}>Select at least 1 kanji to begin.</div>
              ) : writeDone ? (
                <div style={{ padding: 36, textAlign: "center", borderRadius: 18, border: `1px solid ${theme.border}`, background: theme.glass, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)" }}>
                  <div style={{ fontSize: 32, marginBottom: 10 }}>🎉</div>
                  <div style={{ fontSize: 20, fontWeight: 900, color: theme.text }}>All Done!</div>
                  <div style={{ marginTop: 8, fontWeight: 800, color: theme.muted }}>You finished your selected kanji.</div>
                  <div style={{ marginTop: 18, display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
                    <button onClick={practiceWriteAgain} style={pill(theme, { active: true })}>Practice Again</button>
                    <button onClick={() => setWritePickerOpen(true)} style={pill(theme)}>▦ Select</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ padding: 14, borderRadius: 16, background: theme.isDark ? "rgba(255,255,255,0.07)" : "rgba(255, 214, 224, 0.55)", border: `1px solid ${theme.isDark ? theme.border : "rgba(214,52,71,0.20)"}`, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      <div style={{ width: 4, height: 40, background: theme.text, borderRadius: 2 }} />
                      <div>
                        <div style={{ fontSize: 20, fontWeight: 900, color: theme.text }}>{writeItem.meaning}</div>
                        <div style={{ fontSize: 13, fontWeight: 900, color: theme.muted, marginTop: 2 }}>{writeItem.readingKana || "—"}</div>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                      <div style={{ padding: "6px 12px", borderRadius: 999, background: theme.glass, fontSize: 12, fontWeight: 900, color: theme.text, whiteSpace: "nowrap", border: `1px solid ${theme.border}`, boxShadow: theme.glowSoft, backdropFilter: "blur(16px)" }}>Stroke {Math.min(strokeIndex + 1, totalStrokes)}/{totalStrokes}</div>
                      <button onClick={() => speakJP(writeItem.readingKana)} disabled={!writeItem.readingKana} style={miniRound(theme)} title="Listen">🔊</button>
                    </div>
                  </div>

                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                    <button onClick={() => { if (strokeIndex > 0) { const next = userStrokes.slice(0, -1); setUserStrokes(next); setStrokeIndex((s) => Math.max(0, s - 1)); redrawCanvas(next); } }} disabled={strokeIndex === 0} style={{ ...smallGlassBtn(theme), opacity: strokeIndex === 0 ? 0.45 : 1, cursor: strokeIndex === 0 ? "not-allowed" : "pointer" }}>↶ Undo</button>
                    <button onClick={resetWrite} style={smallGlassBtn(theme)}>↻ Reset</button>
                  </div>

                  <div style={{ marginBottom: 12 }}>
                    <div ref={padRef} style={{ width: "100%", maxWidth: "500px", aspectRatio: "1 / 1", margin: "0 auto", borderRadius: 18, border: `2px solid ${theme.border}`, overflow: "hidden", background: `repeating-linear-gradient(0deg, transparent, transparent 23px, ${theme.grid} 23px, ${theme.grid} 24px), repeating-linear-gradient(90deg, transparent, transparent 23px, ${theme.grid} 23px, ${theme.grid} 24px)`, position: "relative", touchAction: "none", userSelect: "none", boxShadow: glassShadow(theme.isDark) }}
                      onPointerDown={onPointerDown} onPointerMove={onPointerMove}
                      onPointerUp={finishStroke} onPointerCancel={finishStroke}
                      onPointerLeave={(e) => { if (drawingRef.current.active) finishStroke(e); }}>
                      <svg width="100%" height="100%" viewBox={vgData?.viewBox || "0 0 109 109"} style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
                        {vgData?.paths?.map((d, i) => (<path key={i} d={d} fill="none" stroke={theme.isDark ? "rgba(255,255,255,0.10)" : "rgba(45,27,27,0.12)"} strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />))}
                        {showStrokeHint && vgData?.paths?.[strokeIndex] && (<path d={vgData.paths[strokeIndex]} fill="none" stroke={theme.accent} strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4 6" opacity={0.72} />)}
                      </svg>
                      <canvas ref={canvasRef} width={PAD} height={PAD} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none" }} />
                      {!vgData && (<div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: theme.isDark ? "rgba(0,0,0,0.60)" : "rgba(255,255,255,0.80)", fontWeight: 900, color: theme.text, padding: 16, textAlign: "center", backdropFilter: "blur(12px)" }}>{vgErr ? <div><div style={{ color: theme.accent }}>Could not load stroke data.</div><div style={{ fontSize: 12, marginTop: 6, color: theme.faint }}>{vgErr}</div></div> : "Loading stroke order…"}</div>)}
                    </div>
                  </div>

                  <div style={{ marginBottom: 14 }}>
                    <ProgressBar value01={writeProgress} theme={theme} />
                    <div style={{ marginTop: 8, fontSize: 12, fontWeight: 900, color: theme.faint, textAlign: "center" }}>{writeIndex + 1} / {writeOrder.length}</div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 10, alignItems: "center" }}>
                    <button onClick={goPrevWrite} disabled={writeIndex === 0} style={{ ...pill(theme), opacity: writeIndex === 0 ? 0.55 : 1, cursor: writeIndex === 0 ? "not-allowed" : "pointer", justifySelf: "start" }}>← Prev</button>
                    <button onClick={() => openPopup("💡 Memory hint", <div style={{ fontWeight: 900, color: theme.text, lineHeight: 1.5 }}><div style={{ color: theme.muted, fontSize: 12, marginBottom: 10 }}>{writeItem.kanji} • {writeItem.meaning}</div><div style={{ fontSize: 16 }}>{writeItem.story || "No hint available."}</div></div>)} style={{ border: "none", background: "transparent", cursor: "pointer", color: theme.accent, fontWeight: 900, display: "inline-flex", alignItems: "center", gap: 8, justifySelf: "center", padding: "10px 8px" }}>
                      <span>💡</span><span>Memory hint</span>
                    </button>
                    <button onClick={goNextWrite} disabled={writeIndex >= writeOrder.length - 1} style={{ ...pill(theme, { active: true }), opacity: writeIndex >= writeOrder.length - 1 ? 0.55 : 1, cursor: writeIndex >= writeOrder.length - 1 ? "not-allowed" : "pointer", justifySelf: "end" }}>Next →</button>
                  </div>
                </>
              )}
            </div>
          )}

          {/* LEARN TAB */}
          {tab === "learn" && (
            <div style={{ ...glassCard, padding: 14 }}>
              <div style={{ fontWeight: 900, color: theme.muted, fontSize: 13, marginBottom: 10 }}>Selected: {selectedLearnKanji.length} (min 5)</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button onClick={() => setLearnPickerOpen((o) => !o)} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>▦</span><span>Select</span></button>
                <button onClick={shuffleLearn} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>⤮</span><span>Shuffle</span></button>
                <button onClick={resetLearn} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>⟲</span><span>Reset</span></button>
              </div>
              <KanjiPicker open={learnPickerOpen} title="Select Kanji" deck={deck}
                selected={selectedLearnKanji}
                setSelected={(v) => { setSelectedLearnKanji(v); const base = v.length ? deck.filter((d) => v.includes(d.kanji)) : deck; setLearnQueue(shuffle(base)); setLearnStartSize(base.length); }}
                theme={theme} minSelected={5}
                onMinFail={(min) => openPopup("Select more kanji", <div style={{ fontWeight: 900, color: theme.text }}>Please select at least {min} kanji.</div>)}
                onClose={() => setLearnPickerOpen(false)} />
              <div style={divider} />
              <div style={{ marginBottom: 12 }}>
                <ProgressBar value01={learnProgress} theme={theme} />
                <div style={{ marginTop: 8, fontSize: 12, fontWeight: 900, color: theme.faint, textAlign: "center" }}>{Math.max(0, learnStartSize - learnQueue.length)} / {learnStartSize}</div>
              </div>
              <div style={{ borderRadius: 18, border: `1px solid ${theme.border}`, background: theme.glass, boxShadow: glassShadow(theme.isDark), backdropFilter: "blur(18px)", padding: 18 }}>
                {!learnItem ? (
                  <div style={{ textAlign: "center", padding: 14 }}>
                    <div style={{ fontSize: 32, marginBottom: 10 }}>🎉</div>
                    <div style={{ fontWeight: 900, color: theme.text, fontSize: 18 }}>Complete!</div>
                    <button onClick={resetLearn} style={{ ...pill(theme, { active: true }), marginTop: 14 }}>Start Again</button>
                  </div>
                ) : (
                  <>
                    <div style={{ textAlign: "center", padding: "10px 8px 6px" }}>
                      <div style={{ fontSize: 72, fontWeight: 900, lineHeight: 1 }}>{learnItem.kanji}</div>
                      {showEnglish && <div style={{ marginTop: 8, fontWeight: 900, color: theme.accent }}>{learnItem.meaning}</div>}
                      <button onClick={() => speakJP(learnItem.readingKana)} disabled={!learnItem.readingKana} style={{ ...pill(theme, { active: true }), marginTop: 12, opacity: learnItem.readingKana ? 1 : 0.6 }}>🔊 Listen</button>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginTop: 14 }}>
                      {learnChoices.map((c) => (
                        <button key={c.key} onClick={() => answerLearn(c)} style={{ borderRadius: 18, padding: "20px 14px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: theme.glass2, color: theme.text, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", textAlign: "center" }}>
                          <div style={{ fontSize: 26, color: theme.accent, marginBottom: 6 }}>{c.reading}</div>
                          {showEnglish && c.reading && <div style={{ fontSize: 12, fontWeight: 900, color: theme.muted }}>{c.romaji}</div>}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* TEST TAB */}
          {tab === "test" && (
            <div style={{ ...glassCard, padding: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ fontWeight: 900, color: theme.text, fontSize: 14 }}>Questions:</div>
                  <select value={testCount} onChange={(e) => setTestCount(e.target.value)} style={{ borderRadius: 12, padding: "10px 12px", border: `1px solid ${theme.border}`, fontWeight: 900, outline: "none", background: theme.glass, color: theme.text, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)" }}>
                    {allowedCounts.map((n) => <option key={n} value={n}>{n}</option>)}
                  </select>
                </div>
                <button onClick={startTest} style={pill(theme, { active: true })}>▶️ Start</button>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
                <button onClick={startTest} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>⤮</span><span>Shuffle</span></button>
                <button onClick={resetTest} style={actionChip(theme)}><span style={{ opacity: 0.9 }}>⟲</span><span>Reset</span></button>
              </div>
              <div style={divider} />
              {!testActive ? (
                <div style={{ padding: 36, textAlign: "center", color: theme.muted, fontWeight: 900 }}>Click Start to begin the test.</div>
              ) : testPos >= testItems.length ? (
                <div style={{ padding: 22, textAlign: "center" }}>
                  <div style={{ fontSize: 32, marginBottom: 10 }}>🎉</div>
                  <div style={{ fontSize: 20, fontWeight: 900, color: theme.text }}>Test Complete!</div>
                  <div style={{ marginTop: 10, fontWeight: 900, color: theme.muted, fontSize: 16 }}>Score: {testScore} / {testItems.length} ({Math.round((testScore / testItems.length) * 100)}%)</div>
                  <div style={{ marginTop: 18, display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
                    <button onClick={startTest} style={pill(theme, { active: true })}>Retry</button>
                    <button onClick={startTest} style={pill(theme)}>⤮ Shuffle & Retry</button>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                    <div style={{ fontWeight: 900, color: theme.muted, fontSize: 13 }}>Question {testPos + 1} / {testItems.length}</div>
                    <div style={{ fontWeight: 900, color: theme.accent, fontSize: 13 }}>Score: {testScore}</div>
                  </div>
                  <ProgressBar value01={testProgress} theme={theme} />
                  <div style={{ marginTop: 14, borderRadius: 18, border: `1px solid ${theme.border}`, background: theme.glass, boxShadow: glassShadow(theme.isDark), backdropFilter: "blur(18px)", padding: 18, textAlign: "center" }}>
                    <div style={{ fontSize: 72, fontWeight: 900, lineHeight: 1 }}>{testItem.kanji}</div>
                    {showEnglish && <div style={{ marginTop: 8, fontWeight: 900, color: theme.accent }}>{testItem.meaning}</div>}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginTop: 14 }}>
                    {testChoices.map((c) => (
                      <button key={c.key} onClick={() => answerTest(c)} style={{ borderRadius: 18, padding: "20px 14px", fontWeight: 900, cursor: "pointer", border: `1px solid ${theme.border}`, background: theme.glass2, color: theme.text, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", textAlign: "center" }}>
                        <div style={{ fontSize: 26, color: theme.accent, marginBottom: 6 }}>{c.reading}</div>
                        {showEnglish && c.reading && <div style={{ fontSize: 12, fontWeight: 900, color: theme.muted }}>{c.romaji}</div>}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ALL TAB */}
          {tab === "all" && (
            <div style={{ ...glassCard, padding: 14 }}>
              <div style={{ fontWeight: 900, color: theme.muted, marginBottom: 12, fontSize: 13 }}>Total Kanji: {deck.length}</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
                {deck.map((k) => (
                  <div key={k.kanji} style={{ borderRadius: 18, padding: 14, border: `1px solid ${theme.border}`, background: theme.glass, boxShadow: theme.glowSoft, backdropFilter: "blur(18px)", textAlign: "center" }}>
                    <div style={{ fontSize: 40, fontWeight: 900, marginBottom: 6 }}>{k.kanji}</div>
                    {showEnglish && <div style={{ fontWeight: 900, color: theme.accent, marginBottom: 6, fontSize: 13 }}>{k.meaning}</div>}
                    <div style={{ color: theme.muted, fontWeight: 900, fontSize: 13 }}>{k.readingKana || "—"}</div>
                    {showEnglish && k.readingKana && <div style={{ marginTop: 4, color: theme.faint, fontWeight: 900, fontSize: 11 }}>{kanaToRomaji(k.readingKana)}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ===========================
   ROOT APP
=========================== */
export default function App() {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [dark, setDark] = useState(false);
  const [sound, setSound] = useState(true);

  const theme = useMemo(() => {
    const accent = "#d63447";
    if (dark) {
      return {
        isDark: true, accent, bg: "#000000", bg2: "#070707",
        text: "#ffffff", muted: "rgba(255,255,255,0.78)", faint: "rgba(255,255,255,0.55)",
        border: "rgba(255,255,255,0.12)", track: "rgba(255,255,255,0.09)",
        glass: "rgba(255,255,255,0.08)", glass2: "rgba(255,255,255,0.06)",
        glassStrong: "rgba(255,255,255,0.12)", modal: "rgba(12,12,12,0.78)",
        overlay: "rgba(0,0,0,0.55)", card: "rgba(10,10,10,0.70)",
        selected: "rgba(255,255,255,0.12)", checkBorder: "rgba(255,255,255,0.35)",
        grid: "rgba(255,255,255,0.06)",
        glow: `0 12px 30px ${accent}33`, glowSoft: "0 12px 30px rgba(0,0,0,0.35)",
      };
    }
    return {
      isDark: false, accent, bg: "#fff7f8", bg2: "#fff0f3",
      text: "#2d1b1b", muted: "rgba(45,27,27,0.72)", faint: "rgba(45,27,27,0.52)",
      border: "rgba(214,52,71,0.16)", track: "rgba(255,255,255,0.55)",
      glass: "rgba(255,255,255,0.70)", glass2: "rgba(255,255,255,0.60)",
      glassStrong: "rgba(255,255,255,0.82)", modal: "rgba(255,255,255,0.74)",
      overlay: "rgba(18,10,12,0.32)", card: "rgba(255,255,255,0.72)",
      selected: "rgba(214,52,71,0.12)", checkBorder: "rgba(45,27,27,0.22)",
      grid: "rgba(214,52,71,0.04)",
      glow: `0 12px 30px ${accent}26`, glowSoft: "0 12px 30px rgba(29, 12, 18, 0.10)",
    };
  }, [dark]);

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.background = dark ? "#000" : "#fff7f8";
  }, [dark]);

  if (!selectedLevel) {
    return <LevelSelect onSelect={setSelectedLevel} theme={theme} dark={dark} setDark={setDark} sound={sound} setSound={setSound} />;
  }

  return <PracticeView level={selectedLevel} onBack={() => setSelectedLevel(null)} sound={sound} setSound={setSound} dark={dark} setDark={setDark} />;
}
